<div class="flex-column gap pt-2">
    <div class="flex gap">
        <div class="flex-column gap flex-3 flex-overflow-initial">
            <div class="flex gap">
                <app-text-input
                    class="flex-1"
                    [formField]="fields.name"
                    label="service.settings.group.fields.name"
                />
                <app-number-input
                    class="flex-1"
                    [formField]="fields.creditAmount"
                    label="service.settings.group.fields.creditAmount"
                    [maxFractionDigits]="2"
                />
            </div>
            <app-text-area-input
                [formField]="fields.description"
                label="service.settings.group.fields.description"
            />
            <app-check-input
                [formField]="fields.active"
                label="service.settings.group.fields.active"
            />
            <div class="flex gap">
                <app-date-input
                    class="flex-1"
                    [formField]="fields.validFrom"
                    label="service.settings.group.fields.validFrom"
                    timeType="startOfDay"
                />
                <app-date-input
                    class="flex-1"
                    [formField]="fields.validTo"
                    [showClear]="true"
                    label="service.settings.group.fields.validTo"
                    timeType="endOfDay"
                />
                <app-number-input
                    class="flex-1"
                    [formField]="fields.creditValidityDays"
                    label="service.settings.group.fields.creditValidityDays"
                    [maxFractionDigits]="0"
                />
            </div>
        </div>
        <app-color-input
            class="flex-1"
            [formField]="fields.color"
        />
    </div>
    @if (data.serviceGroup) {
        <app-card-table
            #offersTable
            tableKey="socialCreditGroupOffers"
            tableTitle="socialCredits.groups.offers.title"
            translatePrefix="socialCredits.groups."
            [columns]="offerColumns"
            [hideCheckboxes]="true"
            [additionalFilter]="filters"
            [gridData]="store.data.getSocialServiceOfferGroups()"
            [refreshCallback]="store.api.getSocialServiceOfferGroups"
            [refreshCallbackFragment]="creditGroupOffersFragment"
            (createCallback)="editOffer()"
            (detailCallback)="editOffer($event)"
            (deleteCallbackWithEvent)="deleteOffer($event)"
        />
        <app-card-table
            #membersTable
            tableKey="socialCreditGroupMembers"
            tableTitle="socialCredits.groups.members.title"
            translatePrefix="socialCredits.groups."
            [columns]="memberColumns"
            [hideCheckboxes]="true"
            [additionalFilter]="filters"
            [gridData]="store.data.getFolderGroups()"
            [refreshCallback]="store.api.getFolderGroups"
            [refreshCallbackFragment]="creditGroupMembersFragment"
            (createCallback)="editMember()"
            (detailCallback)="editMember($event)"
            (deleteCallbackWithEvent)="deleteMember($event)"
        />
    } @else {
        <div>{{ 'socialCredits.groups.saveFirst' | translate }}</div>
    }
</div>
<div
    #dialogFooter
    class="p-dialog-footer"
>
    <app-action-buttons
        [primaryButtonDisability]="fields().invalid() || store.loadingAny()"
        [primaryButtonLoading]="store.loadingAny()"
        [secondaryButtonDisability]="store.loadingAny()"
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"
    />
</div>
